import image from '@/assets/images/manufacturers/techem.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'TECHEM',
  label: 'techem',
  image,
}));
